var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4456",
    "data-name": "Group 4456",
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.884,
    height: 15.884,
    viewBox: "0 0 15.884 15.884",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M0,0H15.884V15.884H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M9.956,9.645V14.9H4A5.295,5.295,0,0,1,9.956,9.645Zm-.662-.7a3.971,3.971,0,1,1,3.971-3.971A3.97,3.97,0,0,1,9.295,8.942Zm3.834,4.576,2.34-2.34.936.936L13.129,15.39l-2.34-2.34.936-.936,1.4,1.4Z",
    transform: "translate(-1.353 -0.338)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationIcon);
export default __webpack_public_path__ + "static/media/verificationIcon.9c31804e1360973d730a0f4a703513d0.svg";
export { ForwardRef as ReactComponent };